import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../ai-suite/theme';

/** A titled card of 我的练习's progress. */
export const ProgressSection = memo(
  ({ title, children }: { title: string; children: ReactNode }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          gap: rpx(12),
          padding: rpx(16),
          borderRadius: rpx(14),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.card,
        }}
      >
        <Typography.Text size={rpx(15)} bold color={aiColors.foreground}>
          {title}
        </Typography.Text>
        {children}
      </View>
    );
  },
);
